<template>
  <div class="panel-item first-panel">
    <div class="title_name">{{ name }}产品数据汇总</div>
    <div class="summary_box">

      <div class="m_r_15">
        <div style="display: flex;">
          <img class="money_img" src="../../../../assets/money.png" alt="">
          <div class="num_txt">产品新增数</div>
        </div>
        <div style="display: flex;">
          <div class="num_num">{{ salesdata.product_count }}</div>
          <div class="num_txt2">单</div>
        </div>
      </div>
      <div>
        <div style="display: flex;">
          <img class="money_img" src="../../../../assets/money.png" alt="">
          <div class="num_txt">产品失效数</div>
        </div>
        <div style="display: flex;">
          <div class="num_num">{{ salesdata.product_invalid_count }}</div>
          <div class="num_txt2">单</div>
        </div>
      </div>
      <div class="m_r_15">
        <div style="display: flex;">
          <img class="money_img" src="../../../../assets/money.png" alt="">
          <div class="num_txt">有出单产品数</div>
        </div>
        <div style="display: flex;">
          <div class="num_num">{{ salesdata.product_order_count }}</div>
          <div class="num_txt2">单</div>
        </div>
      </div>
      <div>
        <div style="display: flex;">
          <img class="money_img" src="../../../../assets/money.png" alt="">
          <div class="num_txt">申样发货数</div>
        </div>
        <div style="display: flex;">
          <div class="num_num">{{ salesdata.product_sample_count }}</div>
          <div class="num_txt2">单</div>
        </div>
      </div>
      <div class="m_r_15">
        <div style="display: flex;">
          <img class="money_img" src="../../../../assets/money.png" alt="">
          <div class="num_txt">有效付款订单数</div>
        </div>
        <div style="display: flex;">
          <div class="num_num">{{ salesdata.product_pay_order_count }}</div>
          <div class="num_txt2">单</div>
        </div>
      </div>
      <div>
        <div style="display: flex;">
          <img class="money_img" src="../../../../assets/money.png" alt="">
          <div class="num_txt">产品失效恢复数</div>
        </div>
        <div style="display: flex;">
          <div class="num_num">{{ salesdata.product_invalid_recover_count }}</div>
          <div class="num_txt2">个</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    salesdata: {
      type: Object,
      default: {}
    }
  },
  watch: {
    salesdata(newVal) {
      // console.log('新数据', newVal)
    }
  }
}
</script>

<style lang="scss" scoped>
.panel-item {
  width: 490px;
  height: 420px;
  background: url(../../../../assets/_s-image_sector_bg.png) no-repeat;
  background-size: 100% 100%;

  &.first-panel {
    margin: 30px 0 35px 0;
  }
}

.title_name {
  padding: 30px 0 23px 100px;
  font-weight: 400;
  font-size: 22px;
  color: #FFFFFF;
}


.summary_box {
  height: 300px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 0 20px;
  padding-top: 20px;
}

.money_img {
  margin-right: 4px;
  width: 39px;
  height: 23px;
}

.num_txt {
  font-weight: 400;
  font-size: 18px;
  color: #F3FFFE;
}

.num_num {
  margin-left: 39px;
  font-weight: 600;
  font-size: 28px;
  color: #00A8FF;
}

.num_txt2 {

  margin-top: 10px;
  margin-left: 10px;
  font-weight: 400;
  font-size: 16px;
  color: #F3FFFE;
}

.panel-item_flex {
  // margin-top: 32px;
  margin-right: 32px;
  margin-left: 32px;
  padding: 0 32rpx;
  display: flex;
  // justify-content: space-between;
}

.m_b_20 {
  margin-bottom: 20px;
}

.m_r_15 {
  width: 220px;
  margin-right: 10px;
}
</style>